import Numeral from 'numeral'
import { FormatPriceProps } from './Type'

Numeral.locale('fr')

/**
 * @description build the numeral format
 * @returns price format
 */
const buildFormat = (format: string | undefined, removeCurrency: boolean | undefined): string => {
  if (format) {
    return format
  }
  if (removeCurrency) {
    return '0,0.[00]'
  }
  return '0,0.[00] $'
}

/**
 * @description return price if it's a number, or convert to number before return
 * @returns price to format
 */
const buildPrice = (price: string | number): number => {
  if (!price) {
    return 0
  }
  if (typeof price === 'string') {
    return parseFloat(price)
  }
  return price
}

export const FormatPriceAsString = ({
  price,
  format,
  removeCurrency,
  currencySuffix,
}: FormatPriceProps): string => {
  const newFormat = buildFormat(format, removeCurrency)
  const newPrice = buildPrice(price)
  const newCurrency = currencySuffix || ''
  return `${Numeral(newPrice).format(newFormat)}${newCurrency ? ` ${newCurrency}` : ''}`
}
